var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.options,"item-text":"name","label":_vm.labelName,"rules":_vm.checkRules,"clearable":""},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}})
}
var staticRenderFns = []

export { render, staticRenderFns }